import { EdiBrltlFreightItemTable } from "../EdiBrltlFreightItemTable";
import { EdiFuncAck } from "../EdiFuncAck";
import { EdiMapErrors } from "../EdiMapErrors";
import { EdiOrderCarrierPay } from "../EdiOrderCarrierPay";
import { EdiOrderHandlingRequirements } from "../EdiOrderHandlingRequirements";
import { EdiOrderOverview } from "../EdiOrderOverview";
import { EdiOrderRates } from "../EdiOrderRates";
import { EdiOrderReply } from "../EdiOrderReply";
import { EdiPartnerValues } from "../EdiPartnerValues";
import { Button, Checkbox, DataHeader, DataSource, HorizontalSpacer, Image, Label, Layout, Panel, Switch, Tab, Table, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutViewEdiOrder extends Layout {
    actionPanel: Panel;
    buttonFuncAckRawData: Button;
    buttonLinkTender: Button;
    buttonLock: Button;
    buttonPurposeSwap: Button;
    buttonReplyRawData: Button;
    buttonSuggestedPricing: Button;
    buttonTenderRawData: Button;
    buttonUsers: Button;
    checkboxFloorLoadedFreight: Checkbox;
    checkboxHighValue: Checkbox;
    checkboxIntercompany: Checkbox;
    checkboxNoDisplay: Checkbox;
    checkboxPreloaded: Checkbox;
    checkboxRoundTrip: Checkbox;
    checkboxTeamsRequired: Checkbox;
    classicButton: Button;
    dataheaderEdiOrder: DataHeader;
    errorLayout: EdiMapErrors;
    generalPanel: Panel;
    horizontalspacer12: HorizontalSpacer;
    horizontalspacer13: HorizontalSpacer;
    horizontalspacer16: HorizontalSpacer;
    horizontalspacer17: HorizontalSpacer;
    imageGoToOrder: Image;
    labelAdvSearch: Label;
    labelHazmatCommodity: Label;
    labelHyphen: Label;
    labelLabel5: Label;
    labelOrderId: Label;
    labelOrderNumber: Label;
    labelOrderStatus: Label;
    labelTemperatureRange: Label;
    labelTenderNumber: Label;
    labelTransmitStatus: Label;
    layoutEdiOrderCarrierPay: EdiOrderCarrierPay;
    layoutFA: EdiFuncAck;
    layoutFreightItems: EdiBrltlFreightItemTable;
    layoutHandlingReqs: EdiOrderHandlingRequirements;
    layoutOverview: EdiOrderOverview;
    layoutPartnerValues: EdiPartnerValues;
    layoutRates: EdiOrderRates;
    layoutReply: EdiOrderReply;
    panelCommodityCheckboxes: Panel;
    panelCommodityExtra: Panel;
    panelCommodityHazmat: Panel;
    panelErrors: Panel;
    panelGeneralUpdate: Panel;
    panelHazmatComponents: Panel;
    panelOutbound: Panel;
    panelTenderInfo: Panel;
    sourceBrltlEdiOrderHdrXFgp: DataSource;
    sourceEdiBrltlOrderFreightGroupItem: DataSource;
    sourceEdiFunctionalAck: DataSource;
    sourceEdiMapError: DataSource;
    sourceEdiOrder: DataSource;
    sourceEdiStop: DataSource;
    sourceResponsibleHist: DataSource;
    sourceViewEdiOrder: DataSource;
    stopsTable: Table;
    switchHazmatRouting: Switch;
    switchIgnoreErrors: Switch;
    tabAccessorials: Tab;
    tabBrltlFreightItems: Tab;
    tabCarrierPay: Tab;
    tabCommodity: Tab;
    tabEquipment: Tab;
    tabErrors: Tab;
    tabFA: Tab;
    tabGeneral: Tab;
    tabMapErrors: Tabset;
    tabOverview: Tab;
    tabPartnerInfo: Tab;
    tabRate: Tab;
    tabReply: Tab;
    tabStops: Tab;
    tabTenderInfo: Tab;
    tabsetAddOrders: Tabset;
    teamPanel: Panel;
    tempPanel: Panel;
    textReadyToSend: Textbox;
    textboxAgentPayeeId: Textbox;
    textboxAppType: Textbox;
    textboxBlnum: Textbox;
    textboxCommodity: Textbox;
    textboxCommodityId: Textbox;
    textboxConsigneeRefno: Textbox;
    textboxCreateDate: Textbox;
    textboxCustomerId: Textbox;
    textboxDefMoveType: Textbox;
    textboxDefaultEquipMatchId: Textbox;
    textboxDirection: Textbox;
    textboxEdiError: Textbox;
    textboxEnteredUserId: Textbox;
    textboxEquipmentTypeIdEquipment: Textbox;
    textboxEquipmentTypeIdGeneral: Textbox;
    textboxGs06GroupCntlno: Textbox;
    textboxGsDateTime: Textbox;
    textboxHazmatCode: Textbox;
    textboxId: Textbox;
    textboxInitialPurposeTypeDescr: Textbox;
    textboxIsa13IntrCntlno: Textbox;
    textboxOperationsUser: Textbox;
    textboxOrderLength: Textbox;
    textboxOrderMode: Textbox;
    textboxOrderType: Textbox;
    textboxOrderValue: Textbox;
    textboxOrderedBy: Textbox;
    textboxOrderedDate: Textbox;
    textboxOrderedMethod: Textbox;
    textboxPalletsHowMany: Textbox;
    textboxPartnerId: Textbox;
    textboxPieces: Textbox;
    textboxPlanningComment: Textbox;
    textboxPreloadTrailerId: Textbox;
    textboxPurposeTypeDescr: Textbox;
    textboxRateSource: Textbox;
    textboxRbdTimezoneId: Textbox;
    textboxRespondByDate: Textbox;
    textboxRevenueCodeId: Textbox;
    textboxShipmentId: Textbox;
    textboxSt02TrxsetCntlno: Textbox;
    textboxTemperatureMax: Textbox;
    textboxTemperatureMin: Textbox;
    textboxTenderStatus: Textbox;
    textboxTractorType: Textbox;
    textboxVersion: Textbox;
    textboxWeight: Textbox;
}
